import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../features/layout/RequirePermission';
import { ReportsPage } from '../../features/reports/ReportsPage';
import {
  fromReportParams,
  reportSearchSchema,
  toReportParams,
} from '../../features/reports/search';

export const Route = createFileRoute('/_authed/reports')({
  validateSearch: reportSearchSchema,
  component: Guarded,
});

function ReportsRoute(): React.JSX.Element {
  const params = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportsPage
      search={fromReportParams(params)}
      onSearch={(next) => void navigate({ search: toReportParams(next) })}
    />
  );
}

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="reports.view">
      <ReportsRoute />
    </RequirePermission>
  );
}
